// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement("img");
  overlayImage.setAttribute("src", `${image.src}`);
  const overlay = document.createElement("div");
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = "50%";
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    // Only insert overlay if it still should be visible (image still exists and is being hovered)
    if (image.parentElement && activeOverlays.has(image)) {
      image.parentElement.insertBefore(overlay, image);
    }
    image.style.opacity = "100%";
  };

  // Handle case where image fails to load
  overlayImage.onerror = () => {
    toggleLoadingSpinner(image);
    image.style.opacity = "100%";
    // Remove from activeOverlays if load failed
    if (activeOverlays.has(image)) {
      activeOverlays.delete(image);
    }
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute("class", "image-magnify-full-size");
  container.setAttribute("aria-hidden", "true");
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = "var(--gradient-background)";
  // Set z-index to keep it below modals but above other content
  container.style.zIndex = "5";

  // CRITICAL: Make the overlay NOT capture mouse events
  // This allows clicks to pass through to the elements underneath
  container.style.pointerEvents = "none";
}

function toggleLoadingSpinner(image) {
  const loadingSpinner =
    image.parentElement.parentElement.querySelector(`.loading__spinner`);
  if (loadingSpinner) {
    loadingSpinner.classList.toggle("hidden");
  }
}

function moveWithHover(image, event, zoomRatio, overlay) {
  if (!overlay || !overlay.parentNode) return;

  // Get container rect - could be the image's parent div, not the image itself
  const imageContainer = image.closest(".product__media");
  if (!imageContainer) return;

  const container = imageContainer.getBoundingClientRect();
  const ratio = image.height / image.width;

  // Check if mouse is inside container - if not, remove the overlay
  if (
    event.clientX < container.left ||
    event.clientX > container.right ||
    event.clientY < container.top ||
    event.clientY > container.bottom
  ) {
    // Mouse is outside the container, remove the overlay
    if (overlay && overlay.parentNode) {
      overlay.parentNode.removeChild(overlay);
    }
    if (activeOverlays && activeOverlays.has(image)) {
      activeOverlays.delete(image);
    }
    image.style.opacity = "100%";
    return;
  }

  // calculate mouse position
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (container.width / 100)}%`;
  const yPercent = `${yPosition / ((container.width * ratio) / 100)}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);
  // We don't attach mouse events to the overlay itself anymore
  // because it has pointer-events: none
  return overlay;
}

// Track active overlays
let activeOverlays = new Map();
let isFullyLoaded = false;
let zoomRatioGlobal = 2;

// Handler functions defined at global scope
const handleContainerMouseEnter = function (event) {
  const container = event.currentTarget;
  const image = container.querySelector("img");

  if (!image || activeOverlays.has(image)) {
    return;
  }

  // Don't create overlay if page is still loading
  if (!isFullyLoaded) {
    return;
  }

  // Only create overlay if image is complete (fully loaded)
  if (!image.complete) {
    return;
  }

  const overlay = magnify(image, zoomRatioGlobal);
  activeOverlays.set(image, overlay);
  moveWithHover(image, event, zoomRatioGlobal, overlay);
};

const handleContainerMouseLeave = function (event) {
  const container = event.currentTarget;
  const image = container.querySelector("img");
  if (!image) {
    return;
  }

  // Immediately remove the overlay when mouse leaves
  if (activeOverlays.has(image)) {
    const overlay = activeOverlays.get(image);
    if (overlay && overlay.parentNode) {
      overlay.parentNode.removeChild(overlay);
    }
    activeOverlays.delete(image);
  } else {
  }

  // Also ensure image opacity is reset
  image.style.opacity = "100%";
};

const handleContainerMouseMove = function (event) {
  const container = event.currentTarget;
  const image = container.querySelector("img");
  if (!image) return;

  if (activeOverlays.has(image)) {
    const overlay = activeOverlays.get(image);
    moveWithHover(image, event, zoomRatioGlobal, overlay);
  }
};

const handleContainerClick = function (event) {
  // Remove overlay immediately on click to allow modal to open
  const container = event.currentTarget;
  const image = container.querySelector("img");
  if (image && activeOverlays.has(image)) {
    const overlay = activeOverlays.get(image);
    if (overlay && overlay.parentNode) {
      overlay.parentNode.removeChild(overlay);
    }
    activeOverlays.delete(image);
  }
  // Reset image opacity
  if (image) {
    image.style.opacity = "100%";
  }
  // Don't prevent default - let the click open the modal
};

function initializeHoverZoom() {
  // Find media containers that need hover magnification
  const mediaContainers = document.querySelectorAll(
    '[data-magnify-hover="true"]'
  );



  // Clean up any previously attached events
  mediaContainers.forEach((container, index) => {
   
    // Find the image inside the container
    const image = container.querySelector("img");
    if (!image) {
      return;
    }

 

    if (activeOverlays.has(image)) {
      const overlay = activeOverlays.get(image);
      if (overlay && overlay.parentNode) {
        overlay.parentNode.removeChild(overlay);
      }
      activeOverlays.delete(image);
    }

    // Remove existing event listeners from the container
    container.removeEventListener("mouseenter", handleContainerMouseEnter);
    container.removeEventListener("mouseleave", handleContainerMouseLeave);
    container.removeEventListener("mousemove", handleContainerMouseMove);
    container.removeEventListener("click", handleContainerClick);

    // Set up event listeners for hover zoom on the container
    container.addEventListener("mouseenter", handleContainerMouseEnter);
    container.addEventListener("mouseleave", handleContainerMouseLeave);
    container.addEventListener("mousemove", handleContainerMouseMove);
    container.addEventListener("click", handleContainerClick);
  });

}

function enableZoomOnHover(zoomRatio) {
  zoomRatioGlobal = zoomRatio;
  // Check if device is mobile (touch-enabled)
  const isMobile = "ontouchstart" in window || navigator.maxTouchPoints > 0;

  // If mobile, don't enable zoom at all - let clicks open the modal
  if (isMobile) {
    return;
  }


  // Mark as fully loaded after a delay to prevent issues during initial load
  document.addEventListener("DOMContentLoaded", function () {
 
    setTimeout(() => {
      isFullyLoaded = true;
    }, 1000); // 1 second delay after DOMContentLoaded
  });

  // Ensure our functionality runs after other scripts
  document.addEventListener("DOMContentLoaded", function () {
    setTimeout(initializeHoverZoom, 100);
  });

  // Re-initialize on page changes (for Shopify's AJAX navigation)
  document.addEventListener("page:loaded", function () {
    isFullyLoaded = false;
    setTimeout(() => {
      isFullyLoaded = true;
      initializeHoverZoom();
    }, 1000);
  });

  // Also observe for any dynamic changes to the product media
  observeProductMediaChanges();

  // Add a global safety net to clean up stuck overlays
  document.addEventListener(
    "mousemove",
    function (event) {
      // Check if mouse is over any magnify container
      const containers = document.querySelectorAll(
        '[data-magnify-hover="true"]'
      );
      let isOverContainer = false;

      containers.forEach((container) => {
        const rect = container.getBoundingClientRect();
        if (
          event.clientX >= rect.left &&
          event.clientX <= rect.right &&
          event.clientY >= rect.top &&
          event.clientY <= rect.bottom
        ) {
          isOverContainer = true;
        }
      });

      // If mouse is not over any container, remove all overlays
      if (!isOverContainer && activeOverlays.size > 0) {
        activeOverlays.forEach((overlay, image) => {
          if (overlay && overlay.parentNode) {
            overlay.parentNode.removeChild(overlay);
          }
          image.style.opacity = "100%";
        });
        activeOverlays.clear();
      }
    },
    { passive: true }
  );
}

function observeProductMediaChanges() {
  // Create a MutationObserver to watch for changes to the product media
  const mediaGallery = document.querySelector("media-gallery");
  if (!mediaGallery) {
    return;
  }


  const observer = new MutationObserver((mutations) => {
    // Check if any mutation is NOT related to our magnify overlay
    let shouldReinitialize = false;

    for (const mutation of mutations) {
      // Ignore mutations related to our magnify overlays
      if (
        mutation.target.classList &&
        mutation.target.classList.contains("image-magnify-full-size")
      ) {
        continue;
      }

      // Check if added/removed nodes include our overlay
      let hasMagnifyOverlay = false;
      if (mutation.addedNodes) {
        mutation.addedNodes.forEach((node) => {
          if (
            node.classList &&
            node.classList.contains("image-magnify-full-size")
          ) {
            hasMagnifyOverlay = true;
          }
        });
      }
      if (mutation.removedNodes) {
        mutation.removedNodes.forEach((node) => {
          if (
            node.classList &&
            node.classList.contains("image-magnify-full-size")
          ) {
            hasMagnifyOverlay = true;
          }
        });
      }

      if (!hasMagnifyOverlay) {
        shouldReinitialize = true;
        break;
      }
    }

    if (shouldReinitialize) {
    
      // When product media changes, reinitialize our hover zoom
      initializeHoverZoom();
    } else {
      console.log("🔇 Ignoring mutations - all related to magnify overlays");
    }
  });

  // Start observing
  observer.observe(mediaGallery, {
    childList: true,
    subtree: true,
    // Removed attributes watching to prevent style/opacity changes from triggering
  });


  // Also add a mouseleave handler to the entire media gallery
  // to ensure we remove all overlays when the mouse leaves the product media area
  mediaGallery.addEventListener("mouseleave", function (event) {
    // Remove all active overlays
    activeOverlays.forEach((overlay, image) => {
      if (overlay && overlay.parentNode) {
        overlay.parentNode.removeChild(overlay);
      }
      image.style.opacity = "100%";
    });
    activeOverlays.clear();
  });
}

// Initialize with zoom ratio of 2
enableZoomOnHover(2);

// Add CSS for the magnify overlay and disable any other hover effects
(function () {
  const style = document.createElement("style");
  style.textContent = `
    .image-magnify-full-size {
      position: absolute;
      z-index: 10;
      background-repeat: no-repeat;
      cursor: zoom-in;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      pointer-events: none; /* CRITICAL: This allows clicks to pass through to elements beneath */
    }
    .image-magnify-lightbox {
      cursor: zoom-in !important;
    }
    
    /* Disable image-scroll-preview functionality */
    [data-magnify-hover="true"] .image-scroll-preview-overlay,
    [data-magnify-hover="true"] .image-preview-indicator {
      display: none !important;
    }
    
    /* Override any other hover effects */
    [data-magnify-hover="true"]::after {
      display: none !important;
    }
    
    /* Ensure our hover takes precedence */
    .product__media-item:hover [data-magnify-hover="true"] {
      z-index: 10;
    }
  `;
  document.head.appendChild(style);

  // Add document click handler to remove overlays on ANY click
  document.addEventListener(
    "click",
    function (event) {
      // For ANY click (including on the image), remove all overlays
      // This ensures clicking on the image will always open the modal
      if (
        typeof activeOverlays !== "undefined" &&
        activeOverlays instanceof Map
      ) {
        activeOverlays.forEach((overlay, image) => {
          if (overlay && overlay.parentNode) {
            overlay.parentNode.removeChild(overlay);
          }
          image.style.opacity = "100%";
        });
        activeOverlays.clear();
      }

      // Don't prevent default behavior or stop propagation
      // Let the click event continue to trigger modal opening
    },
    { capture: false }
  );

  // Also actively disable any image scroll preview functionality
  document.addEventListener("DOMContentLoaded", function () {
    disableConflictingFunctionality();
  });

  function disableConflictingFunctionality() {
    // Find and remove any image scroll preview elements
    const overlays = document.querySelectorAll(
      ".image-scroll-preview-overlay, .image-preview-indicator"
    );
    overlays.forEach((overlay) => {
      if (overlay.parentNode) {
        overlay.parentNode.removeChild(overlay);
      }
    });
  }
})();
